/* ============================================================
   LAILA AND ME — CHRISTMAS 2026 PRODUCT PAGE SKIN
   Theme: Turbo 9.2.0 (seasonal duplicate theme only)
   File:  assets/christmas-skin.js

   Injects the three elements CSS cannot create on its own:
     1. the curtain that opens the page under the plain header
     2. a padded wrapper around the gallery so the hanging hook
        is not clipped by .lm-pdp .lm-section { overflow: hidden }
     3. the nameplate under the hero image

   Touches nothing else. Safe to remove by deleting the two
   asset tags in theme.liquid.
   ============================================================ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function buildCurtain() {
    if (document.querySelector('.lm-xmas-curtain')) return;

    var anchor =
      document.querySelector('.lm-pdp-section') ||
      document.querySelector('.lm-pdp');
    if (!anchor) return;

    var label = document.body.getAttribute('data-xmas-curtain') || 'Christmas 2026';

    var curtain = document.createElement('div');
    curtain.className = 'lm-xmas-curtain';
    curtain.innerHTML = '<span></span>';
    curtain.querySelector('span').textContent = label;

    anchor.parentNode.insertBefore(curtain, anchor);
  }

  function frameGallery() {
    var main = document.querySelector('.lm-pdp .lm-gallery-main');
    if (!main) return;
    if (main.parentNode && main.parentNode.classList.contains('lm-xmas-frame')) return;

    var frame = document.createElement('div');
    frame.className = 'lm-xmas-frame';
    main.parentNode.insertBefore(frame, main);
    frame.appendChild(main);

    var text = document.body.getAttribute('data-xmas-plate');
    if (!text) return;

    var plate = document.createElement('div');
    plate.className = 'lm-xmas-plate';
    plate.innerHTML = '<span></span>';
    plate.querySelector('span').textContent = text;

    frame.parentNode.insertBefore(plate, frame.nextSibling);
  }

  ready(function () {
    if (!document.body.classList.contains('lm-xmas')) return;
    buildCurtain();
    frameGallery();
  });
})();